// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Link Verify Button Component should match snapshot 1`] = `
<Fragment>
  <Button
    className="getVerifyLinkButton"
    disabled={false}
    onClick={[Function]}
    size="small"
    type=""
  >
    Click here to verify
  </Button>
  <Text
    copyable={true}
    textToCopy="http://example.com"
  />
</Fragment>
`;
